// /coaches/text: the batch Text flow for the coaches ticked on the list (location.state.ids).
// Landing here with nothing selected (a reload, a typed URL) goes back to the list.
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { AdminSidebar } from '../components/AdminShell';
import TextFlow from '../components/crm/TextFlow';
import './AdminDashboard.css';
import '../components/AdminShell.css';
import './CoachesPage.css';

export default function TextFlowPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const ids = location.state?.ids;
  if (!Array.isArray(ids) || ids.length === 0) return <Navigate to="/coaches" replace />;
  return (
    <div className="adm">
      <div className="adm__shell">
        <AdminSidebar active="coaches" />
        <main className="adm__main">
          <div className="adm__card cr-section">
            <TextFlow ids={ids} onDone={() => navigate('/coaches')} />
          </div>
        </main>
      </div>
    </div>
  );
}
